/**
 * TabWithIcon
 * 
 * @Author: Focci
 * @Date: 2023-08-07 13:51:05
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-07 13:51:05
 */

'use client'

import PropTypes from 'prop-types'
import clsx from 'clsx'
import { ButtonBase } from '@comp/material'

function BarTabItem({
  data = {},
  actived = false,
  className = '',
  activedClassName = 'text-primary'
}) {
  return (
    <div 
      className={clsx([
        'flex items-center justify-center gap-1 px-2 md:px-4',
        'whitespace-nowrap hover:bg-cf0 w-full h-10',
        actived && activedClassName,
        data.disabled && 'text-helper',
        className,
      ])}
    >
      <div className="hidden md:block">
        {data.icon}
      </div>
      <span className="text-f.8 md:text-f.9">{data.label}</span>
      {!!data.badge && (
        <span className="text-f.6 bg-cd8 rounded-full px-1 text-c57">
          {data.badge}
        </span>
      )}
    </div>
  )
}

export default function TabWithIcon({
  value,
  showDisabled = true,
  options = [],
  onChange = () => {},
}) {
  return (
    <div 
      className="
        flex items-center bg-white border rounded-sm w-full 
        md:w-auto justify-start md:justify-around overflow-x-auto
      "
    >
      {options.map((option, index) => (showDisabled || (!showDisabled && !option.disabled)) && (
        <div 
          key={index} 
          className={clsx(['flex flex-auto h-full', index > 0 && 'border-l'])}
        >
          <ButtonBase 
            className="w-full"
            disabled={option.disabled}
            onClick={() => onChange(option)}
          >
            <BarTabItem 
              actived={value === option.value}
              data={option}
            />
          </ButtonBase>
        </div>
      ))}
    </div>
  )
}

TabWithIcon.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
}
